export enum FormAlarmSectionAllEnum {
  MONITOR_CHECKBOX = "monitorCheckbox",
  ALERT_CHECKBOX = "alertCheckbox",
  SENSOR_NAME_INPUT = "sensorNameInput",
  WARNING_INPUT = "warningInput",
  ALARM_INPUT = "alarmInput",
  RUL_WARNING_INPUT = "rulWarningInput",
  RUL_ALARM_INPUT = "rulAlarmInput",
}
